import { Button, Grid, MenuItem, TextField } from "@material-ui/core";
import React, { useState } from "react";
import {
  getCurrentDate,
  getLastMonthDate,
  getNextMonthDate,
} from "utils/dateGetters.js";

import { Autocomplete } from "@material-ui/lab";
import CustomMUIDataTable from "components/MUIDatatable/CustomMUIDataTable";
import CustomizedSnackbars from "components/CustomizedSnackbars/CustomizedSnackbars";
import DateField from "components/CustomFields/DateField.js";
import LoaderBar from "components/LoaderBar/LoaderBar";
import PageTitle from "components/PageTitle/PageTitle";
import { SnackbarHandler } from "components/Handlers/SnackbarHandler";
import { Typography } from "components/Wrappers/Wrappers";
import { dbGet } from "utils/DBFetchers.js";
import { format } from "date-fns";
import { getRoleName } from "utils/roleNameGetter";
import logo from "images/logoPagesRS.jpg";
// styles
import useStyles from "./styles";

const getDateFormatted = (date) => {
  return format(date, "dd/MM/yy");
};

const blankFilters = {
  begin: getDateFormatted(
    new Date(getCurrentDate().getFullYear(), getCurrentDate().getMonth(), 1),
  ),
  beginDate: new Date(
    getCurrentDate().getFullYear(),
    getCurrentDate().getMonth(),
    1,
  ),
  end: getDateFormatted(
    new Date(
      getNextMonthDate().getFullYear(),
      getNextMonthDate().getMonth(),
      1,
    ),
  ),
  endDate: new Date(
    getCurrentDate().getFullYear(),
    getCurrentDate().getMonth(),
    1,
  ),
  distributors: "",
  pharmagroups: "",
  pharmacies: "",
};

const blankAllResults = {
  distributors: [],
  pharmagroups: [],
  pharmacies: [],
};

const selectorOptions = [
  { value: "distributors", label: "Distribuidores" },
  { value: "pharmagroups", label: "Grupos" },
  { value: "pharmacies", label: "Farmacias" },
];

export default function SettlementsPage() {
  var classes = useStyles();
  const [filters, setFilters] = useState(blankFilters);
  const [allResults, setAllResults] = useState(blankAllResults);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [tableData, setTableData] = useState([]);
  const role = getRoleName();
  const hasPermissions =
    role === "admin" || role === "super_admin" || role === "full";
  const [snackbarStatus, snackbarOpen, onCloseSnackbar] = SnackbarHandler();

  const columns = [
    {
      name: "Distribuidor",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "Cód. farm",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "Farmacia",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "Domicilio",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "Comuna",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "RUT Paciente",
      options: {
        filter: false,
        display: role === "admin" || role === "full" ? "excluded" : true,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "Fecha",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
        sortCompare: (order) => {
          return (a, b) => {
            var dateSplitA = a.data.split("/");
            var dateSplitB = b.data.split("/");
            const dateA = new Date(
              dateSplitA[2],
              dateSplitA[1],
              dateSplitA[0],
            ).getTime();
            const dateB = new Date(
              dateSplitB[2],
              dateSplitB[1],
              dateSplitB[0],
            ).getTime();
            return (dateA < dateB ? -1 : 1) * (order === "desc" ? 1 : -1);
          };
        },
      },
    },
    {
      name: "Producto",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "SKU",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "Precio",
      options: {
        display: hasPermissions ? true : "excluded",
        sort: hasPermissions,
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "Costo",
      options: {
        display: hasPermissions ? true : "excluded",
        sort: hasPermissions,
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "Descuento (%)",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "Bonif. Unit.",
      options: {
        display: hasPermissions ? true : "excluded",
        sort: hasPermissions,
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "Cantidad",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "Bonif. total",
      options: {
        display: hasPermissions ? true : "excluded",
        sort: hasPermissions,
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
    {
      name: "RUT Farmacia",
      options: {
        filter: false,
        setCellHeaderProps: () => ({
          style: { fontWeight: "bold", whiteSpace: "nowrap" },
        }),
        setCellProps: () => ({ style: { whiteSpace: "nowrap" } }),
      },
    },
  ];

  const handleChange = (event) => {
    setFilters({ ...filters, [event.target.name]: event.target.value });
  };
  const handleAutoCompletePharmacyChange = (event, newValue) => {
    setFilters({ ...filters, pharmacies: newValue ? newValue.id : "" });
  };
  const handleBeginDateChange = (date) => {
    var dateOnFirstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    setFilters({
      ...filters,
      beginDate: dateOnFirstDay,
      begin: getDateFormatted(dateOnFirstDay),
    });
  };
  const handleEndDateChange = (date) => {
    var dateOnFirstDayNext = new Date(
      date.getFullYear(),
      date.getMonth() + 1,
      1,
    );
    var dateOnFirstDay = new Date(date.getFullYear(), date.getMonth(), 1);
    setFilters({
      ...filters,
      endDate: dateOnFirstDay,
      end: getDateFormatted(dateOnFirstDayNext),
    });
  };
  const validDateFilters = () => {
    let validDate =
      filters.beginDate &&
      filters.endDate &&
      filters.beginDate > filters.endDate
        ? false
        : true;
    return validDate;
  };

  const handleApplyFilters = () => {
    if (!validDateFilters()) {
      snackbarOpen("error", "Rango de fechas inválido");
      return;
    }

    let pharmacyId = `${
      filters.pharmacies ? `&pharmacy_id=${filters.pharmacies}` : ""
    }`;
    let distributorId = `${
      filters.distributors ? `&distributor_id=${filters.distributors}` : ""
    }`;
    let pharmagroupId = `${
      filters.pharmagroups ? `&pharmagroup_id=${filters.pharmagroups}` : ""
    }`;
    let programId = `&program_id=${localStorage.getItem("programId")}`;

    setIsLoading(true);
    //?from_date=<dd/mm/yy>&to_date=<dd/mm/yy>
    dbGet(
      `sales/liquidation?from_date=${filters.begin}&to_date=${filters.end}${programId}${pharmacyId}${distributorId}${pharmagroupId}`,
    )
      .then((data) => {
        let tableData = [];
        tableData = data.map((row) => [
          row.distributor?.name,
          row.pharmacy?.code,
          row.pharmacy?.name,
          row.pharmacy?.address,
          row.pharmacy?.commune?.name,
          row.patient?.rut,
          format(new Date(row.transaction_date + " EDT"), "dd/MM/yyyy"),
          row.presentation?.name,
          row.presentation?.sku,
          row.list_price?.value,
          row.cost,
          row.discount_percentage === -1 ? "No aplica" : row.discount_percentage,
          row.unitary_discount_amount,
          row.total_units,
          row.total_discount_amount,
          row.pharmacy?.rut,
        ]);
        setTableData(tableData);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };
  const handleCleanFilters = () => {
    setFilters(blankFilters);
    setSelectedCategory("");
  };

  const handleSetCategory = (value) => {
    setSelectedCategory(value);
    if (allResults[value].length === 0) getResults(value);
  };

  var [isLoading, setIsLoading] = useState(false);
  const getResults = (category) => {
    setIsLoading(true);
    dbGet(category)
      .then((data) => {
        if (category === "distributors") {
          data = data.filter((x) => x.works_with_independents && x.id !== 19);
        }
        data.push({ id: "", name: "Sin filtro" });
        let mapped = data.map((item) => {
          return {
            id: item["id"],
            name:
              category === "pharmacies"
                ? `${item["name"]} - ${item["code"]}`
                : `${item["name"]}`,
          };
        });
        setAllResults({
          ...allResults,
          [category]: mapped,
        });
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  // Program switch logic
  const [programId, setProgramId] = useState(localStorage.getItem("programId"));
  const updateTableDataOnProgramIdChange = () => {
    setTableData([]);
    handleApplyFilters();
  };
  React.useEffect(() => {
    function checkProgramId() {
      const item = localStorage.getItem("programId");
      setProgramId(item);
    }
    window.addEventListener("storage", checkProgramId);
    return () => {
      window.removeEventListener("storage", checkProgramId);
    };
  }, []);
  React.useEffect(() => {
    if (!tableData) return; // no fetch on page load
    updateTableDataOnProgramIdChange();
  }, [programId]);

  return (
    <>
      <CustomizedSnackbars
        severity={snackbarStatus.severity}
        mssg={snackbarStatus.message}
        open={snackbarStatus.open}
        onClose={onCloseSnackbar}
      />
      <div>
        <PageTitle
          title="Liquidaciones"
          // button={
          //   <img src={logo} alt="logo" className={classes.logotypeImage} />
          // }
        />
      </div>
      <Grid
        style={{ display: "flex", margin: 0 }}
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
        spacing={4}
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <div className={classes.smallItems}>
              <Typography variant="h4" className={classes.text}>
                Selección
              </Typography>
            </div>
            <div className={classes.smallItems}>
              <Typography className={classes.text} weight="bold">
                Período
              </Typography>
              <DateField
                helperText="Fecha desde (mes y año)"
                views={["year", "month"]}
                minDate={new Date("2013-10-01")}
                maxDate={getCurrentDate()}
                format={"MM/yyyy"}
                name="begin"
                value={filters.beginDate ? filters.beginDate : getCurrentDate()}
                onChange={handleBeginDateChange}
                fieldClassName={classes.smallField}
              />
            </div>
            <div
              className={classes.smallItems}
              style={{ justifyContent: "flex-end" }}
            >
              <DateField
                helperText={
                  !validDateFilters()
                    ? "Fecha hasta no puede ser menor a fecha desde"
                    : "Fecha hasta (mes y año)"
                }
                name="end"
                views={["month", "year"]}
                minDate={new Date("2013-10-01")}
                maxDate={getCurrentDate()}
                format={"MM/yyyy"}
                value={filters.endDate ? filters.endDate : getCurrentDate()}
                onChange={handleEndDateChange}
                fieldClassName={classes.smallField}
                error={!validDateFilters()}
              />
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={12} style={{ marginTop: "0.5%" }}>
            {hasPermissions && (
              <div className={classes.generalPurposeItemsAlt}>
                <TextField
                  id="selection"
                  select
                  className={classes.generalPurposeField}
                  value={selectedCategory}
                  onChange={(e) => {
                    handleSetCategory(e.target.value);
                    setFilters({
                      ...filters,
                      distributors: "",
                      pharmagroups: "",
                      pharmacies: "",
                    });
                  }}
                  label="Seleccione"
                  helperText="Categoría"
                  variant="outlined"
                  margin="dense"
                >
                  {selectorOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
                {selectedCategory !== "pharmacies" ? (
                  <TextField
                    id="selectedCategory"
                    select
                    className={classes.generalPurposeFieldAlt}
                    label="Seleccione"
                    name={selectedCategory}
                    value={selectedCategory ? filters[selectedCategory] : ""}
                    onChange={handleChange}
                    variant="outlined"
                    margin="dense"
                  >
                    {(selectedCategory ? allResults[selectedCategory] : []).map(
                      (option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ),
                    )}
                  </TextField>
                ) : (
                  <Autocomplete
                    freeSolo
                    style={{ marginTop: "-0.5%" }}
                    onChange={handleAutoCompletePharmacyChange}
                    getOptionLabel={(option) =>
                      option.name ? option.name : ""
                    }
                    options={allResults.pharmacies ? allResults.pharmacies : []}
                    renderInput={(params) => (
                      <TextField
                        className={classes.generalPurposeField}
                        {...params}
                        placeholder="Seleccione"
                        margin="dense"
                        variant="outlined"
                      />
                    )}
                  />
                )}
              </div>
            )}

            <div className={classes.buttonSpacing}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleApplyFilters}
              >
                Aplicar
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleCleanFilters}
              >
                Limpiar
              </Button>
            </div>
          </Grid>
        </Grid>

        {isLoading ? (
          <LoaderBar />
        ) : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <CustomMUIDataTable
                title="Liquidaciones"
                data={tableData}
                columns={columns}
              />
            </Grid>
          </Grid>
        )}
      </Grid>
    </>
  );
}
